import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const attempts = [{
  title: 'Prohibir su uso',
  desc: 'Tratar de prohibir el uso de IA solo genera que la usen a escondidas y sin supervisión.'
}, {
  title: 'Tutoriales técnicos',
  desc: "Buscar tutoriales en YouTube te deja más confundido con términos como 'Machine Learning' o 'Algoritmos'."
}, {
  title: 'Ignorar el tema',
  desc: "Esperar que sea una 'moda pasajera' está dejando a tus hijos en desventaja frente a un mundo que ya exige estas habilidades."
}, {
  title: 'Creer que es para genios',
  desc: 'Creer que la IA es solo para genios de la computación te quita el poder de usarla como asistente personal.'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedAttempts() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg text-brand-text max-w-2xl mx-auto" data-id="element-5">
            Abordar la IA con las herramientas del pasado solo genera más
            frustración.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid sm:grid-cols-2 gap-6" data-id="element-6">
          {attempts.map((attempt, index) => <motion.div key={index} variants={item} className="bg-cream-50 rounded-2xl p-6 border border-cream-200 hover:shadow-soft transition-shadow duration-300" data-id="element-7">
              <div className="flex items-start gap-4" data-id="element-8">
                <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-9" />
                <div data-id="element-10">
                  <h3 className="font-bold text-lg text-brand-dark mb-2" data-id="element-11">
                    {attempt.title}
                  </h3>
                  <p className="text-brand-text leading-relaxed" data-id="element-12">
                    {attempt.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}